import { render, staticRenderFns } from "./DeploymentList.vue?vue&type=template&id=508a55d3&scoped=true"
import script from "./DeploymentList.vue?vue&type=script&lang=js"
export * from "./DeploymentList.vue?vue&type=script&lang=js"
import style0 from "./DeploymentList.vue?vue&type=style&index=0&id=508a55d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508a55d3",
  null
  
)

export default component.exports